import styled from 'styled-components';

export const CampaignExportContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
